import React from "react";
import { Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";

export default function UpdatePaymentMethodModal({ show, onHide }) {
  const history = useHistory();
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      style={{ borderRadius: "4px" }}
      dialogClassName="update-payment-modal"
    >
      <Modal.Header
        closeButton
        style={{
          borderBottom: "none",
          padding: "14px 20px",
        }}
      >
        <Modal.Title
          style={{
            fontSize: "18px",
            fontWeight: 700,
            color: "#111827",
            marginTop: "4px",
          }}
        >
          Update your Payment Method
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: "0px 20px 10px 20px" }}>
        <p
          style={{
            fontSize: "14px",
            color: "#374151",
            lineHeight: "1.6",
            marginBottom: "10px",
          }}
        >
          We&apos;ve upgraded our payment system to Square. Your previously
          saved card is no longer active. Please update your card details to
          keep your subscription running without interruption.
        </p>

        <p
          style={{
            fontSize: "14px",
            color: "#374151",
            lineHeight: "1.6",
            marginBottom: "12px",
          }}
        >
          Without an updated card, your subscription may be paused on your next
          billing date.
        </p>

        <p
          style={{
            fontSize: "14px",
            fontWeight: 600,
            color: "#111827",
            marginBottom: "6px",
          }}
        >
          Here&apos;s how to do it (takes less than a minute):
        </p>

        <ol style={{ paddingLeft: "18px", marginBottom: "12px" }}>
          <li style={{ fontSize: "14px", color: "#374151", lineHeight: "1.9" }}>
            Click the Profile icon (top right corner)
          </li>
          <li style={{ fontSize: "14px", color: "#374151", lineHeight: "1.9" }}>
            Go to My Plan
          </li>
          <li style={{ fontSize: "14px", color: "#374151", lineHeight: "1.9" }}>
            Scroll down to the Payment Method section
          </li>
          <li style={{ fontSize: "14px", color: "#374151", lineHeight: "1.9" }}>
            Click Edit Card and enter your card details
          </li>
        </ol>

        <p
          style={{
            fontSize: "14px",
            color: "#111827",
            lineHeight: "1.6",
            marginBottom: "0px",
            fontWeight: 600,
          }}
        >
          You can also refer to this video clip to get better understanding of
          the process. To view the video{" "}
          <a
            href="https://youtu.be/naVbixTRmoU?si=f34AaN_9CYDqHjtV"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#2C7BE5",
              fontWeight: 500,
              textDecoration: "none",
            }}
          >
            Click Here
          </a>
        </p>
      </Modal.Body>

      <Modal.Footer
        style={{
          borderTop: "none",
          padding: "6px 20px 16px 20px",
          justifyContent: "flex-end",
        }}
      >
        <button
          onClick={() => {
            onHide();
            history.push("/settings/myplan");
          }}
          style={{
            height: "32px",
            padding: "0 20px",
            border: "none",
            borderRadius: "4px",
            background: "#2C7BE5",
            fontSize: "13px",
            color: "#fff",
            cursor: "pointer",
            fontWeight: 500,
            width: "168px",
          }}
        >
          Update Card Now
        </button>
      </Modal.Footer>
    </Modal>
  );
}
